import amexCardIcon from "assets/images/IconsCards/Amex.svg"
import dinersCardIcon from "assets/images/IconsCards/DinersClub.svg"
import eloCardIcon from "assets/images/IconsCards/Elo.svg"
import HiperCardIcon from "assets/images/IconsCards/Hipercard.svg"
import masterCardIcon from "assets/images/IconsCards/Mastercard.svg"
import visaCardIcon from "assets/images/IconsCards/Visa.svg"

/**
 * Card brand icons
 */
export const cardBrandIcons = {
  VISA: visaCardIcon,
  MASTERCARD: masterCardIcon,
  ELO: eloCardIcon,
  DINERS: dinersCardIcon,
  AMEX: amexCardIcon,
  HIPERCARD: HiperCardIcon
};

/**
 * Regex patterns for credit card validation - Padrões para identificar bandeiras
 */
export const CARD_PATTERNS = {
  VISA: /^4[0-9]\d{11}(?:\d{3})?$/, // Começa com 4, 13 ou 16 dígitos
  MASTERCARD: /^(5[1-5]\d{14}|2(2[2-9]\d{13}|[3-6]\d{14}|7([01]\d{13}|20\d{12})))$/,
  // MasterCard antigo (51-55) e novo range (2221-2720)
  AMEX: /^3[47]\d{13}$/, // American Express (15 dígitos, começa com 34 ou 37)
  DINERS: /^3(?:0[0-5]|[68]\d)\d{11}$/,
  // Diners Club: 300–305, 36 ou 38, 14 dígitos
  ELO: /^(4011(78|79)|431274|438935|451416|457393|457631|457632|504175|506699|5067[0-6][0-9]|50677[0-8]|509[0-9]{3}|627780|636297|636368|6500(31|32|33|34|35|36|37|38|39)|6504(85|86|87|88|89)|6509(1[1-9]|2[0-9]|3[0-9]|40)|6516(52|53|54|55)|6550(00|01|02|03|04|05|06|07|08|09|10|11|12|13|14|15|16|17|18|19)|6550[2-9]\d|6551[0-9]{2}|6552[0-1][0-9]|65522[0-1])\d{10}|6[0-9]\d{14}$/,
  // ELO: Regex bem completo cobrindo todas faixas documentadas
  HIPERCARD: /^(3841\d{15}|606282\d{10})$/,
  // 60 inicia o padrão tradicional, 3841xxxx... novo formato
};

/**
 * Initial state for new credit card form
 */
export const INITIAL_CARD_STATE = {
  type: "creditcard",
  number: "",
  cvv: "",
  expMonth: "",
  expYear: "",
  card_name: "",
  registry_code: "",
  flag: null
};

/**
 * Card brands configuration - Configuração das bandeiras disponíveis
 */
export const CARD_BRANDS = [
  { nome: 'VISA', icon: cardBrandIcons.VISA },
  { nome: 'MASTERCARD', icon: cardBrandIcons.MASTERCARD },
  { nome: 'ELO', icon: cardBrandIcons.ELO },
  { nome: 'DINERS', icon: cardBrandIcons.DINERS },
  { nome: 'AMEX', icon: cardBrandIcons.AMEX },
  { nome: 'HIPERCARD', icon: cardBrandIcons.HIPERCARD }
];